export const availableLanguages = ['en', 'de', 'ua']